import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import system from './theme';

const MChakraProvider = ({ children }: { children: React.ReactElement }) => (
  <ChakraProvider value={system}>{children}</ChakraProvider>
);

export default MChakraProvider;
